import React from "react";
import styled from "styled-components";

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.75rem;
  cursor: pointer;
  ${(props) =>
    props.iconOnly &&
    `
    justify-content: center;
  `}
`;

const HiddenCheckbox = styled.input.attrs({ type: "checkbox" })`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`;

const StyledCheckbox = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  background: ${(props) =>
    props.checked ? "var(--primary-color)" : "var(--background-tertiary)"};
  border: 2px solid
    ${(props) =>
      props.checked ? "var(--primary-color)" : "var(--border-color)"};
  border-radius: 4px;
  transition: var(--transition);

  &:hover {
    border-color: var(--primary-color);
    box-shadow: ${(props) =>
      props.checked
        ? "0 0 6px rgba(212, 175, 55, 0.5)"
        : "0 0 6px rgba(212, 175, 55, 0.2)"};
  }

  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 3px rgba(212, 175, 55, 0.2);
  }

  svg {
    visibility: ${(props) => (props.checked ? "visible" : "hidden")};
    color: black;
    font-size: 12px;
  }
`;

const CheckIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="4"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  margin-right: 0.5rem;
  background-color: ${(props) =>
    props.checked ? "var(--background-tertiary)" : "transparent"};
  border-radius: 50%;
  transition: var(--transition);
  border: 1px solid
    ${(props) => (props.checked ? "var(--primary-color)" : "transparent")};

  &:hover {
    background-color: var(--background-tertiary);
  }
`;

const Label = styled.span`
  margin-left: 0.5rem;
  font-size: 1rem;
  color: var(--text-color);
`;

const Checkbox = ({
  checked = false,
  onChange,
  children,
  icon,
  iconOnly = false,
  ...props
}) => {
  return (
    <CheckboxContainer iconOnly={iconOnly} onClick={onChange} {...props}>
      {icon && <IconContainer checked={checked}>{icon}</IconContainer>}

      {!icon && (
        <>
          <HiddenCheckbox checked={checked} onChange={onChange} />
          <StyledCheckbox checked={checked}>
            <CheckIcon />
          </StyledCheckbox>
        </>
      )}

      {children && !iconOnly && <Label>{children}</Label>}
    </CheckboxContainer>
  );
};

export default Checkbox;
